import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_voryasl0ya: FaireBrandEntity = {
  token: "b_voryasl0ya",
  type: "brand",
  name: "Bayou Gotham Hot Sauce",
  avatarUrl:
    "https://cdn.faire.com/fastly/b3eb93d5a1ec79b458bac48cfddf5285080001756eb4814b8e17750fd041d4e6.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/b8e4bbc09ec3b693f801b00b7a03ab8fc609f3ceea31780cb99678c4054fdace.png",
  logoUrl:
    "https://cdn.faire.com/fastly/b3eb93d5a1ec79b458bac48cfddf5285080001756eb4814b8e17750fd041d4e6.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/b8e4bbc09ec3b693f801b00b7a03ab8fc609f3ceea31780cb99678c4054fdace.png",
  location: "New York, NY, USA",
  minimumOrderDollars: 50,
  rating: 5,
  reviewCount: 8,
  isInsider: true,
  description:
    "Intense Flavor Filled with Heat ’n’ Soul...\n\nRaised in New Orleans, a progeny of immigrant farmers, humble grocers, and determined hot sauce makers, Scotty Peppers took a bite into Big Apple dreams. Bayou Gotham® is an exquisite product line of show-stopping hot sauces — blending his Louisiana roots with fiery flavors from the New York City neighborhoods he now calls home.\n\nNew York City is his heart. New Orleans is his soul. Bayou Gotham® Hot Sauce gets back to deep Louisiana roots while demonstrating a pride for his adopted home of New York City. Scotty Peppers’ goal is to share these sauces and his heritage by offering a small taste of what’s so far been a zest-filled life. \n\nBayou Gotham® is much more than a tale of two cities. It’s a culinary quest filled with heat ‘n’ soul.",
  meta: {
    source: "api",
    importedAt: "2026-07-06T19:20:34.902Z",
    importedBy: "entity-db-cli",
  },
};
